import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.styled.css';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleSmoothScroll = (event, targetId) => {
    if (location.pathname === "/") {
      event.preventDefault();
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 50, // Adjust offset as needed
          behavior: 'smooth',
        });
      }
    }
    setIsMenuOpen(false); // Close the menu on mobile after clicking
  };


  return (
    <header className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'headerSmall border-gray-600' : ''}`}>
      <div className={`container mx-auto px-4 py-4 flex items-center justify-between ${isScrolled ? 'headerSmall' : ''}`}>
        <div className="flex items-center justify-between w-full md:w-auto space-x-4">
          <Link
            to="/"
            className="text-white hover:text-gray-300"
            onClick={location.pathname === "/" ? (e) => handleSmoothScroll(e, 'hero-section') : undefined}
          >
            <span className="artistic-elikon">Elikon</span>
          </Link>
          <button onClick={toggleMenu} className="text-white md:hidden text-2xl focus:outline-none">
            {isMenuOpen ? `✕` : `☰`} {/* Toggle between open/close icon */}
          </button>
        </div>
        <nav className="hidden md:flex items-center space-x-4 md:space-x-8 lg:space-x-12">
          <Link
            to="/"
            className={`${isScrolled || location.pathname !== "/" ? 'text-black' : 'text-white'} hover:text-gray-300`}
            onClick={(e) => handleSmoothScroll(e, 'feta-section')}
          >
            Products
          </Link>
          <Link
            to="/"
            onClick={(e) => handleSmoothScroll(e, 'about-section')}
            className={`${isScrolled || location.pathname !== "/" ? 'text-black' : 'text-white'} hover:text-gray-300`}
          >
            About Us
          </Link>
          <Link to="/contact">
            <button
              className={`${isScrolled || location.pathname !== "/" ? 'text-black' : 'text-white'
                } bg-gradient-to-r from-blue-500 to-indigo-600 py-2 px-6 rounded-full hover:bg-gradient-to-r hover:from-indigo-500 hover:to-blue-600 transition-all duration-300`}
            >
              Let's Talk
            </button>
          </Link>
        </nav>
      </div>
      {isMenuOpen && (
        <nav className="md:hidden bg-gray-900 absolute top-full left-0 w-full z-40 shadow-lg menu-slide-in">
          <ul className="flex flex-col items-center space-y-4 py-6">
            <li>
              <Link
                to="/"
                className="text-white text-lg hover:text-gray-300 transition-colors duration-200"
                onClick={(e) => {
                  handleSmoothScroll(e, 'feta-section');
                  setIsMenuOpen(false);
                }}
              >
                Products
              </Link>
            </li>
            <li>
              <Link
                to="/"
                className="text-white text-lg hover:text-gray-300 transition-colors duration-200"
                onClick={(e) => {
                  handleSmoothScroll(e, 'about-section');
                  setIsMenuOpen(false);
                }}
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="bg-blue-500 text-white px-4 py-2 rounded-full hover:bg-blue-600 transition-all duration-300 text-lg"
                onClick={() => setIsMenuOpen(false)}
              >
                Let's Talk
              </Link>
            </li>
          </ul>
        </nav>
      )}
    </header>

  );
};

export default Header;